export default "__VITE_ASSET__BDhKaOQs__"